module.exports = __webpack_public_path__ + "static/media/rock_temp.b85e2d6c.jpg";